// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b4956ad4","453":"02bd7586","732":"7326a627","977":"a31db3b8"}[chunkId] + ".chunk.js";
};